module.exports = __webpack_public_path__ + "static/media/10000_WAX.aa6f726f.webp";